module.exports = __webpack_public_path__ + "45f5389d972581c8b301361314f09cf3.svg";